import React from 'react';
import { DefaultDepartment } from './default_department';
import { DynamicsBcSelectPaymentTerms } from './payment_terms';
import { DynamicsBcUploadEmail } from './upload_email';
import type { DynamicsBcSettingsModuleProps } from '@src/pages/settings/types';
import { DynamicsBcRoundingDifference } from './rounding_difference';

export const InvoiceForm: React.FC<DynamicsBcSettingsModuleProps> = ({
  dynamicsBcUserDefaultData,
  setDynamicsBcUserDefaultData,
  handleSelectChange,
  currentMonthPaymentTermsError,
  setCurrentMonthPaymentTermsError,
}) => {
  return (
    <>
      <DynamicsBcSelectPaymentTerms
        dynamicsBcUserDefaultData={dynamicsBcUserDefaultData}
        setDynamicsBcUserDefaultData={setDynamicsBcUserDefaultData}
        handleSelectChange={handleSelectChange}
        currentMonthPaymentTermsError={currentMonthPaymentTermsError}
        setCurrentMonthPaymentTermsError={setCurrentMonthPaymentTermsError}
      />

      <DefaultDepartment dynamicsBcUserDefaultData={dynamicsBcUserDefaultData} setDynamicsBcUserDefaultData={setDynamicsBcUserDefaultData} />
      <DynamicsBcUploadEmail dynamicsBcUserDefaultData={dynamicsBcUserDefaultData} setDynamicsBcUserDefaultData={setDynamicsBcUserDefaultData} />
      <DynamicsBcRoundingDifference dynamicsBcUserDefaultData={dynamicsBcUserDefaultData} setDynamicsBcUserDefaultData={setDynamicsBcUserDefaultData} />
    </>
  );
};
